import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import Alert from "../../utils/Alert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ModalChoiseDevices from "../../../site-apps/devices/ModalChoiseDevices";
import axiApi from "../../../ApiCaller";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import {addOrUpdateList} from "core/utils/arrays";

const PreviewDeviceGroup = ({item, setItem, items, setItemsShow, setShowPrev}) => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const [formData, setFormData] = useState({...item});
    const [showModalDevices, setShowModalDevices] = useState(false);
    const [selectedDevices, setSelectedDevices] = useState(item.actives || []);
    const [isLoading, setIsLoading] = useState(false);
    const alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    useEffect(() => {
        setFormData({...item});
        document.addEventListener("devices:modal:select", handleDeviceSelectEvent);

        return () => {
            document.removeEventListener("devices:modal:select", handleDeviceSelectEvent);
        };
    }, [item]);

    const handleSaveDevices = () => {
        axiApi
            .post("/api/devices/edit-groups/", formData)
            .then((resp) => {
                if (formData.id) {
                    items.current.showed = addOrUpdateList(items.current.showed, resp.data.item);
                } else {
                    items.current.showed.push(resp.data.item);
                }

                setItemsShow([...items.current.showed]);
                setItem(resp.data.item);
                setShowPrev(false);
                alert.success(_Tr("Dispositivos"), _Tr("Grupo de dispositivos guardado correctamente"));
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDeviceSelectEvent = (event) => {
        const selectedDevices = event.detail;
        setSelectedDevices([...selectedDevices]);
        setFormData((prev) => ({...prev, actives: [...selectedDevices]}));
        setItem((prev) => ({...prev, actives: [...selectedDevices]}));
    };

    return (
        <>
            <Alert
                showAlert={false}
                setShowAlert={() => {}}
                onlyAlert={true}
                icon="circle-exclamation"
                title="Todos los campos son obligatorios"
                buttomAcept="Aceptar"
            />

            <div className="col preview-row" style={{width: "450px", maxWidth: "450px"}}>
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="preview-card pb-5" style={{width: "450px"}}>
                            <div className="preview-header">
                                <div className="preview-icon">
                                    <FontAwesomeIcon icon="object-group" />
                                </div>
                                <div className="preview-title">
                                    <label>{_Tr("labels.device-groups")}</label>
                                    <div>{formData.name}</div>
                                </div>
                            </div>
                            <Tabs defaultActiveKey="grupo" id="preview-tabs" className="mb-3">
                                <Tab eventKey="grupo" title={_Tr("Grupo")}>
                                    <div className="preview-body">
                                        <h5>{_Tr("Información del Grupo")}</h5>
                                        <div className="mb-3">
                                            <label htmlFor="groupName" className="form-label">
                                                {_Tr("Nombre del Grupo")}
                                            </label>
                                            <input
                                                id="groupName"
                                                type="text"
                                                className="form-control"
                                                value={formData.name || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        name: e.target.value,
                                                    }))
                                                }
                                                placeholder={_Tr("Ingrese el nombre del grupo")}
                                            />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="devices" title={_Tr("Devices")}>
                                    <div className="preview-body">
                                        <div className="row">
                                            <div className="col-10">
                                                <h4>{_Tr("Lista Dispositivos")}</h4>
                                            </div>
                                            <div className="col-2 text-end  mb-3">
                                                <button className="btn btn-primary " onClick={() => setShowModalDevices(true)}>
                                                    <FontAwesomeIcon icon="fa-magnifying-glass" />
                                                </button>
                                            </div>
                                        </div>

                                        <ul className="list-group">
                                            {selectedDevices.length > 0 ? (
                                                selectedDevices.map((device) => (
                                                    <li key={device.uuid} className="list-group-item">
                                                        <div className="row">
                                                            <div className="col-10">
                                                                <strong>
                                                                    {device.uuid} | {device.serial}
                                                                </strong>
                                                                <br />
                                                                <small>
                                                                    {device.asset_name} - {device.model_name}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="list-group-item">{_Tr("No hay dispositivos asociados.")}</li>
                                            )}
                                        </ul>
                                    </div>
                                </Tab>
                            </Tabs>
                            <div className="preview-footer row mt-4 mb-4">
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-secondary me-2"
                                        onClick={() => {
                                            setItem(null);
                                            setShowPrev(false);
                                        }}>
                                        {_Tr("Cerrar")}
                                    </button>
                                    <button className="btn btn-primary" onClick={handleSaveDevices}>
                                        {_Tr("Guardar")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalChoiseDevices
                showModalDevices={showModalDevices}
                setShowModalDevices={setShowModalDevices}
                chosenDevices={selectedDevices}
            />
        </>
    );
};

export default PreviewDeviceGroup;
